import Modal from 'developer_components/newModal';
import ModalDialog from 'components/modal-dialog.dev';
import {error, hasWebpSupport} from 'methods/utils';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';

const webpSupport = hasWebpSupport();

function getGroups() {
    return [
        {
            group: 1,
            imageCount: 1,
            useCount: 0,
            class: ['4wh'],
            stylePadding: ['padding-top:67%;'],
            styleItem: 'width: 100%; height: 100%;',
            condition: (image1) => {
                return image1.width > 740 && image1.width > image1.height;
            }
        }, {
            group: 2,
            imageCount: 2,
            useCount: 0,
            class: ['1hw', '2wh'],
            stylePadding: ['padding-top:133%;', 'padding-top:67%;'],
            styleImage: ['grid-area: 1 / 1 / auto / auto;', 'grid-area: 1 / 2 / auto / span 2;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr 1fr;',
            condition: (image1, image2) => {
                return image1.height > image1.width
                    && image2.width > image2.height;
            }
        }, {
            group: 2,
            imageCount: 2,
            useCount: 0,
            class: ['2wh', '1hw'],
            stylePadding: ['padding-top:67%;', 'padding-top:133%;'],
            styleImage: ['grid-area: 1 / 1 / auto / span 2;', 'grid-area: 1 / 3 / auto / auto;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr 1fr;',
            condition: (image1, image2) => {
                return image1.width > image1.height
                    && image2.height > image2.width;
            }
        }, {
            group: 2,
            imageCount: 2,
            useCount: 0,
            class: ['1hw', '1hw'],
            stylePadding: ['padding-top:133%;', 'padding-top:133%;'],
            styleImage: ['grid-area: 1 / 1 / auto / auto;', 'grid-area: 1 / 2 / auto / auto;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr;',
            condition: (image1, image2) => {
                return image1.height > image1.width
                    && image2.height > image2.width;
            }
        }, {
            group: 3,
            imageCount: 3,
            useCount: 0,
            class: ['2hw', '1wh', '1wh'],
            stylePadding: ['padding-top:133%;', 'padding-top:67%;', 'padding-top:67%;'],
            styleImage: ['grid-area: 1 / 1 / span 2 / auto;', 'grid-area: 1 / 2 / auto / auto;', 'grid-area: 2 / 2 / auto / auto;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr;',
            condition: (image1, image2, image3) => {
                return image1.height > image1.width
                    && image2.width > image2.height
                    && image3.width > image3.height;
            }
        }, {
            group: 3,
            imageCount: 3,
            useCount: 0,
            class: ['1wh', '1wh', '2hw'],
            stylePadding: ['padding-top:67%;', 'padding-top:67%;', 'padding-top:133%;'],
            styleImage: ['grid-area: 1 / 1 / auto / auto;', 'grid-area: 2 / 1 / auto / auto;', 'grid-area: 1 / 2 / span 2 / auto;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr;',
            condition: (image1, image2, image3) => {
                return image1.width > image1.height
                    && image2.width > image2.height
                    && image3.height > image3.width;
            }
        }, {
            group: 3,
            imageCount: 3,
            useCount: 0,
            class: ['2hw', '1hw', '1hw'],
            stylePadding: ['padding-top:133%;', 'padding-top:133%;', 'padding-top:133%;'],
            styleImage: ['grid-area: 1 / 1 / span 2 / span 2;', 'grid-area: 1 / 3 / auto / auto;', 'grid-area: 2 / 3 / auto / auto;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr 1fr;',
            condition: (image1, image2, image3) => {
                return image1.height > image1.width
                    && image2.height > image2.width
                    && image3.height > image3.width;
            }
        }, {
            group: 3,
            imageCount: 3,
            useCount: 0,
            class: ['1hw', '1hw', '2hw'],
            stylePadding: ['padding-top:133%;', 'padding-top:133%;', 'padding-top:133%;'],
            styleImage: ['grid-area: 1 / 3 / auto / auto;', 'grid-area: 2 / 3 / auto / auto;', 'grid-area: 1 / 1 / span 2 / span 2;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr 1fr;',
            condition: (image1, image2, image3) => {
                return image1.height > image1.width
                    && image2.height > image2.width
                    && image3.height > image3.width;
            }
        }, {
            group: 4,
            imageCount: 4,
            useCount: 0,
            class: ['1wh', '1wh', '1wh', '1wh'],
            stylePadding: ['padding-top:67%;', 'padding-top:67%;', 'padding-top:67%;', 'padding-top:67%;'],
            styleImage: ['grid-area: 1 / 1 / auto / auto;', 'grid-area: 1 / 2 / auto / auto;', 'grid-area: 2 / 1 / auto / auto;', 'grid-area: 2 / 2 / auto / auto;'],
            styleItem: 'display: grid; grid-auto-columns: 1fr; grid-auto-rows: 1fr; gap: 8px; grid-template-columns: 1fr 1fr;',
            condition: (image1, image2, image3, image4) => {
                return image1.width > image1.height
                    && image2.width > image2.height
                    && image3.width > image3.height
                    && image4.width > image4.height;
            }
        },
    ];
}

/**
 * Модалка на странице объекта
 */
function HotelPhotogallery() {
    // открытие фотогалереи
    document.querySelectorAll('.js-openGalleryModal').forEach($button => $button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        this._openSecondModal();
    }));

    // открытие ютуба
    document.querySelectorAll('.js-openVideoModal').forEach($button => $button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        new ModalDialog({
            id: 'photogallery-youtube',
            descriptionHTML: $button.dataset.frame,
        });
    }));
}

/**
 * Открываем промежуточную галерею
 */
HotelPhotogallery.prototype._openSecondModal = function() {
    if (!this._secondModal) {
        this._loadSecondModal();
    }

    this._secondModal.open();
}

/**
 * Загружаем модалку
 */
HotelPhotogallery.prototype._loadSecondModal = function() {
    // инициализация модалки
    this._$secondModal = document.getElementById('hotel-second-photogallery-modal');
    if (!this._$secondModal) {
        return error(`#hotel-second-photogallery-modal модалка не найдена`);
    }

    this._secondModal = new Modal(this._$secondModal, {
        backdrop: false,
    });

    // добавляем в модалку кнопку избранного
    let $headerRightBlock    = this._$secondModal.querySelector('.js-headerRightBlock');
    let $shareOpen           = document.querySelector('.js-shareOpen').cloneNode(true);
    let $objectFavoriteHotel = document.querySelector('.js-objectFavoriteHotel').cloneNode(true);

    $headerRightBlock.append($shareOpen);
    $headerRightBlock.append($objectFavoriteHotel);

    if (window.page && typeof window.page._initShare === 'function') {
        window.page._initShare({$shareOpen});
        window.page._initHint();
    }

    // инициализация фоток
    this._initSecondPhotogallery();

    // открываем модалку
    this._openSecondModal();

    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('hotel_gallery_open');
        collectYandexReachGoal(metrikaCollector, 'hotel_gallery_open');
    }
}

/**
 * Открываем основную галерею
 */
HotelPhotogallery.prototype._openMainModal = function(index = 0) {
    if (!this._mainModal) {
        this._loadMainModal(index);
    }

    this._$mainModal.classList.remove('is-opening');
    this._mainModal.open();

    this._swiper.slideToLoop(index, 100);
    this._loadMainPhotogallerySlide(index, false);

    setTimeout(() => {
        this._swiper.loopFix();
    }, 100);
}

/**
 * Загружаем модалку
 */
HotelPhotogallery.prototype._loadMainModal = function(index) {
    // инициализация модалки
    this._$mainModal = document.getElementById('hotel-photogallery-modal');
    if (!this._$mainModal) {
        return error(`#hotel-photogallery-modal модалка не найдена`);
    }

    this._mainModal = new Modal(this._$mainModal, {
        backdrop: false,
        on: {
            close: () => {
                // код продублирован, почему то только так корректно работает прокрутка
                // может связано с overflow: hidden на документе
                if (this._$clickedImage) {
                    this._$clickedImage.scrollIntoView({
                        block: 'center',
                    });
                }
            },
            'before:close': () => {
                // код продублирован, почему то только так корректно работает прокрутка
                // может связано с overflow: hidden на документе
                if (this._$clickedImage) {
                    this._$clickedImage.scrollIntoView({
                        block: 'center',
                    });
                }

                this._closeAnimation();
            },
        },
    });

    // добавляем в модалку кнопку избранного
    let $headerRightBlock    = this._$mainModal.querySelector('.js-headerRightBlock');
    let $shareOpen           = document.querySelector('.js-shareOpen').cloneNode(true);
    let $objectFavoriteHotel = document.querySelector('.js-objectFavoriteHotel').cloneNode(true);

    $headerRightBlock.append($shareOpen);
    $headerRightBlock.append($objectFavoriteHotel);

    if (window.page && typeof window.page._initShare === 'function') {
        window.page._initShare({$shareOpen});
        window.page._initHint();
    }

    // инициализация фоток
    this._initMainPhotogallery();

    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('hotel_gallery_open');
        collectYandexReachGoal(metrikaCollector, 'hotel_gallery_open');
    }
}

/**
 * $el делает opacity с 1 до 0
 * В конце вызывает finishCallback
 */
HotelPhotogallery.prototype._opacityOut = function($el, finishCallback) {
    let myopacity = 1;
    finishCallback = typeof finishCallback === 'function' ? finishCallback : (() => {});

    function MyFadeFunction() {
        if (myopacity > 0) {
            myopacity -= 0.07;

            setTimeout(() => {
                MyFadeFunction()
            }, 10);
        } else {
            $el.remove();

            finishCallback();
        }

        $el.style.opacity = myopacity;
    }

    MyFadeFunction();
}

/**
 * Выбор фотки
 */
HotelPhotogallery.prototype._loadMainPhotogallerySlide = function(index = 0, isAnimate = true) {
    index = +index;

    // повторный вызов
    if (this._prevIndex === index) {
        return false;
    }

    this._prevIndex = index;

    let data;

    this._data.forEach(item => {
        if (item.id == this._$items[index].dataset.id) {
            data = item;
        }
    });

    let src = data.photo;
    if (data.photo_1080_webp && webpSupport) {
        src = data.photo_1080_webp
    } else if (data.photo_1080) {
        src = data.photo_1080;
    }

    // фоток в контейнере
    let $images = [...this._$mainGallery.querySelectorAll('div')];

    // новые фотки добавляем
    let $div = document.createElement('div');
        $div.innerHTML = `<img src="${src}" alt="${data.attr_alt}">`;

    this._$mainGallery.insertAdjacentElement('afterbegin', $div);

    // пред фотки удаляем
    $images.forEach($image => {
        if ($image.classList.contains('removing')) {
            return false;
        }

        $image.classList.add('removing');

        if (!isAnimate) {
            return $image.remove();
        }
        
        this._opacityOut($image);
    });

    // обновляем счетчик
    this._$counter.textContent = `${+index + 1} / ${this._allCount}`;
}

/**
 * Инициализация фоток
 */
HotelPhotogallery.prototype._initMainPhotogallery = function() {
    this._$mainGallery  = this._$mainModal.querySelector('.js-mainGallery');
    this._$navGallery   = this._$mainModal.querySelector('.js-navGallery');
    this._$counter      = this._$mainModal.querySelector('.js-counter');
    this._$leftArrow    = this._$mainModal.querySelector('.js-leftArrow');
    this._$rightArrow   = this._$mainModal.querySelector('.js-rightArrow');
    this._allCount      = this._data.length;

    let items = '';
    this._data.forEach((item, i) => {
        let src = item.photo;
        if (item.photo_1080_webp && webpSupport) {
            src = item.photo_1080_webp;
        } else if (item.photo_1080) {
            src = item.photo_1080;
        }

        items += `
            <div class="item swiper-slide" data-index="${i}" data-id="${item.id}">
                <img class="swiper-lazy swiper-lazy-loaded" src="${src}" loading="lazy">
            </div>
        `.trim();
    });

    this._$navGallery.innerHTML = `
        <div class="nav-photogallery swiper-wrapper">
            ${items}
        </div>
    `.trim();

    this._$items = [...this._$navGallery.querySelectorAll('.item')];

    Swiper.use([Navigation, Pagination]);

    this._swiper = new Swiper(this._$navGallery, {
        slidesPerView: 'auto',
        // loop: true,
        // loopPreventsSlide: false,
        centeredSlides: true,
        resizeObserver: true,
        updateOnWindowResize: true,
        // Disable preloading of all images
        preloadImages: false,
        watchSlidesProgress: true,
    });

    // срабатывает когда кликаешь по слайдеру
    this._swiper.on('click', (swiper, event) => {
        let index = +event.target.dataset.index;

        this._swiper.slideToLoop(index, 100);
        this._changeAnimationImage(index);
        this._loadMainPhotogallerySlide(index);
    });

    // срабатывает при прокрутки слайдера
    this._swiper.on('slideChange', (swiper) => {
        let index = swiper.activeIndex;

        this._swiper.slideToLoop(index, 100);
        this._changeAnimationImage(index);
        this._loadMainPhotogallerySlide(index);
    });

    // левая стрелка
    this._$leftArrow.addEventListener('click', () => {
        this._swiper.slidePrev(100);
        this._changeAnimationImage(this._swiper.realIndex);
        this._loadMainPhotogallerySlide(this._swiper.realIndex);
    });

    // правая стрелка
    this._$rightArrow.addEventListener('click', () => {
        this._swiper.slideNext(100);
        this._changeAnimationImage(this._swiper.realIndex);
        this._loadMainPhotogallerySlide(this._swiper.realIndex);
    });

    window.addEventListener('keydown', (e) => {
        switch(e.keyCode) {
            case 37: // влево
                this._$leftArrow.dispatchEvent(new Event('click'));
                break;
            case 39: // вправо
                this._$rightArrow.dispatchEvent(new Event('click'));
                break;
        }
    });

    // открытие модалки
    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('hotel_gallery_open');
        collectYandexReachGoal(metrikaCollector, 'hotel_gallery_open');
    }
}

/**
 * Инициализация фоток
 */
HotelPhotogallery.prototype._initSecondPhotogallery = function() {
    this._$secondGallery     = this._$secondModal.querySelector('.js-mainGallery');
    this._$photogalleryJson  = this._$secondModal.querySelector('.js-photogalleryJson');
    this._data               = JSON.parse(this._$photogalleryJson.innerHTML);
    this._$photogalleryJson.remove();

    this._$secondGallery.innerHTML = renderBlocks(this._data);

    this._$secondGallery.querySelectorAll('.js-openMainPhotogalery').forEach($button => $button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const index = this._data.findIndex(item => item.id == $button.dataset.id) || 0;

        this._$clickedImage = $button.querySelector('img');

        this._openMainModal(index);
        this._openAnimation();
    }));

    // открытие модалки
    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('hotel_gallery_open');
        collectYandexReachGoal(metrikaCollector, 'hotel_gallery_open');
    }
}

/**
 * Анимация открытия кликнутой картинки в secondModal
 */
HotelPhotogallery.prototype._openAnimation = function(countOfExecutions = 0) {
    if (countOfExecutions === 100) {
        return;
    }

    this._$mainModal = document.getElementById('hotel-photogallery-modal');
    
    const $mainImage = this._$mainModal.querySelector('img');
    const $header = this._$mainModal.querySelector('.header');
    const clickedImageHeight = (
        this._$clickedImage 
            ? this._$clickedImage.offsetHeight 
            : 0
    );

    if ($mainImage.offsetHeight === 0 || clickedImageHeight === 0) {
        return setTimeout(() => this._openAnimation(countOfExecutions + 1), 100);
    }

    this._opening = true;
    this._$clickedImage.style.opacity = 1;

    const $fantomImage = this._$clickedImage.cloneNode(true);
    document.body.appendChild($fantomImage);
    
    $fantomImage.classList.add('is-fantom-image');
    $fantomImage.style.zIndex = 51;
    $fantomImage.style.objectFit = 'cover';
    $fantomImage.style.position = 'fixed';
    $fantomImage.style.transition = 'all .2s ease';

    changeFantomPosition($fantomImage, this._$clickedImage);
    
    this._$clickedImage.closest('.item').classList.add('is-active');
    this._$clickedImage.style.opacity = 0;

    $mainImage.style.opacity = 0;

    changeFantomPosition($fantomImage, $mainImage);

    $header.classList.remove('is-visible');
    this._$mainModal.classList.add('is-opening');

    setTimeout(() => {
        $header.classList.add('is-visible');

        $fantomImage.remove();
        
        $mainImage.style.opacity = 1;
        
        this._opening = false;
    }, 300);
}

/**
 * Анимация закрытия основной модалки
 */
HotelPhotogallery.prototype._closeAnimation = function() {
    if (this._closing) {
        return;
    }
    this._closing = true;

    this._$mainModal = document.getElementById('hotel-photogallery-modal');

    const $header = this._$mainModal.querySelector('.header');
    const $mainImage = this._$mainModal.querySelector('img');
    const $fantomImage = $mainImage.cloneNode(true);

    document.body.appendChild($fantomImage);

    $header.classList.remove('is-visible');

    $fantomImage.style.zIndex = 51;
    $fantomImage.style.objectFit = 'cover';
    $fantomImage.style.opacity = 1;
    $fantomImage.style.position = 'fixed';
    $fantomImage.style.transition = 'all .2s ease';

    changeFantomPosition($fantomImage, $mainImage);

    $mainImage.style.opacity = 0;

    changeFantomPosition($fantomImage, this._$clickedImage);

    this._$mainModal.classList.replace('is-opening', 'is-closing');

    setTimeout(() => {
        this._$mainModal.classList.remove('is-closing');

        this._$clickedImage.style.opacity = 1;

        $fantomImage.remove();

        this._mainModal.close();

        this._closing = false;
    }, 300);
}

/**
 * Смена фотки в первой модалке для анимации
 */
HotelPhotogallery.prototype._changeAnimationImage = function(index) {
    if (this._prevIndex === index) {
        return false;
    }

    this._$mainModal = document.getElementById('hotel-photogallery-modal');

    const $allClickedImages = document.querySelectorAll('.js-openMainPhotogalery');

    $allClickedImages.forEach(($button, i) => {
        let $img = $button.querySelector('img');
        let $item = $button.closest('.item');

        $img.style.opacity = 1;
        $item.classList.remove('is-active');

        if (i === index) {
            this._$clickedImage = $img;
            
            // $img.style.opacity = 0;
            $item.classList.add('is-active');
        }
    });
}

function changeFantomPosition($fantom, $to) {
    const composition = {
        position: $to.getBoundingClientRect(),
        width: $to.offsetWidth,
        height: $to.offsetHeight,
    };

    $fantom.style.top = `${composition.position.top}px`;
    $fantom.style.left = `${composition.position.left}px`;
    $fantom.style.width = `${composition.width}px`;
    $fantom.style.height = `${composition.height}px`;
}

function renderBlocks(data) {
    let length      = data.length;
    let blockRender = '';

    let renderBlock = (group) => {
        let itemRender = '';

        group.items.forEach((data, i) => {
            let src = data.photo;

            if (group.imageCount == 1) {
                if (data.photo_1080_webp && webpSupport) {
                    src = data.photo_1080_webp
                } else if (data.photo_1080) {
                    src = data.photo_1080;
                }
            } else if (data.photo_720_webp && webpSupport) {
                src = data.photo_720_webp
            } else if (data.photo_720) {
                src = data.photo_720;
            }

            itemRender += `
                <div class="item" style="background: #${data.hex_color};${group.styleImage && group.styleImage[i] ? ' ' + group.styleImage[i] : ''}">
                    <div class="item-inner">
                        <button class="button js-openMainPhotogalery" data-id="${data.id}">
                            <div class="button-inner" style="${group.stylePadding && group.stylePadding[i] ? ' ' + group.stylePadding[i] : ''}">
                                <div class="image-wrapper">
                                    <div class="image-container">
                                        <img src="${src}" alt="${data.attr_alt}">
                                    </div>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>`.trim();
        });

        return `
            <div class="block ${group.class.join('-')}" style="${group.styleItem}">
                ${itemRender}
            </div>`.trim();
    }

    let groups = getGroups();

    while (length > 0) {
        let foundGroup = false;

        groups
            .sort((a, b) => { // сортируем группы
                if (a.useCount > b.useCount) {
                    return 1;
                }

                if (a.useCount < b.useCount) {
                    return -1;
                }

                if (a.group > b.group) {
                    return 1;
                }

                if (b.group > a.group) {
                    return -1;
                }

                return 0;
            })
            .some(group => { // ищем нужную группу
                let result = false;
                if (data.length >= group.imageCount) {
                    result = group.condition(...data.slice(0, group.imageCount));
                }

                if (result) {
                    group.items = [...data.slice(0, group.imageCount)];
                    foundGroup  = group;
                    return true;
                }

                return false;
            });

        if (foundGroup === false) {
            groups[0].items = [...data.slice(0, groups[0].imageCount)];
            foundGroup  = groups[0];
        }

        // уменьшаем data
        data   = data.slice(foundGroup.imageCount);
        length = data.length;

        // рендерим блок
        blockRender += renderBlock(foundGroup);

        // увеличиваем счетчики группы
        groups = groups.map(item => {
            if (item.group == foundGroup.group) {
                item.useCount++;
            }

            if (item.class.join(',') === foundGroup.class.join(',')) {
                item.useCount++;
            }

            return item;
        });
    }

    return blockRender;
}

export default HotelPhotogallery;
